export const formatParamsToDate = (match) => {
  return `${match['params']['month']}/${match['params']['day']}/${match['params']['year']}`
}


export const GetDateFormat = (date) => {
  var month = (date.getMonth() + 1).toString();
  month = month.length > 1 ? month : '0' + month;
  var day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;
  // return month + '/' + day + '/' + date.getFullYear();
  return date.getFullYear() + '/' + month + '/' + day;
}

export const dateObj = new Date();
export const dateFormat = GetDateFormat(dateObj);


export const getImage = (userDataImg, size = 'small') => {
    return userDataImg && Object.keys(userDataImg).length ? userDataImg['thumbnails'][size]['url'] : ''
  }



  export const getDataById = (context, what, id, field) => {
    let a = context["data"][what].filter((item) => item["id"] === id)[0];
    if (field && a) {a = a[field] ? a[field] : null}
    return a;
  };

  export const getDataByUniq = (context, what, id, field) => {
    let a = context["data"][what].filter((item) => item["uniq"] === id)[0];
    if (field && a) {a = a[field] ? a[field] : null}
    return a;
  };



  export const minToHours = (min) => {
    let hrs = min/60;
    hrs = (hrs > 1) ? parseInt(hrs.toString().split('.')[0]) : 0;
    let minutes = min - (hrs * 60);
    if (minutes.toString().length === 1) minutes = '0' + minutes.toString();
    return hrs + ':' + minutes;
  }